"use client";

import type { ResumeDocument } from "@/types/cv";
import { TextField, TextAreaField } from "@/components/cv-builder/fields";
import { CV_BUILDER_EXAMPLE } from "@/components/cv-builder/sample-resume";

interface StepProps {
  resume: ResumeDocument;
  onChange: (next: ResumeDocument) => void;
}

export function IdentityStep({ resume, onChange }: StepProps) {
  const identity = resume.personal_identity;
  const patchIdentity = (patch: Partial<ResumeDocument["personal_identity"]>) =>
    onChange({
      ...resume,
      personal_identity: { ...identity, ...patch },
    });

  return (
    <div className="space-y-4">
      <TextField
        label="Nama lengkap"
        value={identity.name}
        onChange={(name) => patchIdentity({ name })}
        placeholder={CV_BUILDER_EXAMPLE.name}
      />
      <TextField
        label="Email"
        type="email"
        inputMode="email"
        value={identity.email}
        onChange={(email) => patchIdentity({ email })}
        placeholder={CV_BUILDER_EXAMPLE.email}
      />
      <TextField
        label="Nomor HP"
        type="tel"
        inputMode="tel"
        value={identity.phone_number}
        onChange={(phone_number) => patchIdentity({ phone_number })}
        placeholder={CV_BUILDER_EXAMPLE.phoneNumber}
      />
      <TextField
        label="Kota domisili"
        value={identity.location.city}
        onChange={(city) =>
          patchIdentity({ location: { ...identity.location, city } })
        }
        placeholder={CV_BUILDER_EXAMPLE.city}
      />
      <TextField
        label="Link LinkedIn"
        inputMode="url"
        optional
        value={identity.linkedin}
        onChange={(linkedin) => patchIdentity({ linkedin })}
        placeholder={CV_BUILDER_EXAMPLE.linkedin}
      />
      <TextAreaField
        label="Tentang kamu"
        optional
        rows={4}
        value={resume.professional_summary}
        onChange={(professional_summary) =>
          onChange({ ...resume, professional_summary })
        }
        placeholder={CV_BUILDER_EXAMPLE.summary}
      />
    </div>
  );
}
